import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
      
    html,body {
     height: 100%;
    }
    
    body {
     // background: linear-gradient(135deg,#Ff4070,#210D7B) center / cover fixed;
      background: linear-gradient(135deg,#183271,#060E3D) center / cover fixed;
      font-family: "Segoe UI",sans-serif;
    }
    
    
`;

export default GlobalStyle;
